/* ==========================================================================
   MDM — footer accordion for phones.

   On a 390px screen the footer measured 1,989px, 21% of the whole home page.
   1,482px of that was the five link/text blocks stacked at full height.

   Dawn's footer renders each block as a bare <h2> + content pair with no
   disclosure markup, so there is nothing for CSS alone to collapse. Rather
   than fork sections/footer.liquid, this wraps each block in a native
   <details>/<summary> at phone widths and unwraps it again above the
   breakpoint, leaving Dawn's own markup untouched on desktop. <details> is
   used instead of a hand-rolled toggle so keyboard access, screen-reader
   semantics and find-in-page all work without extra code.

   The first block stays open: it carries the brand copy and gives the footer
   something to open on.
   ========================================================================== */

(function () {
  'use strict';

  var BREAKPOINT = '(max-width: 749px)';
  var CLASS = 'mdm-facc';
  var built = [];

  function blocks() {
    var wrap = document.querySelector('.footer__blocks-wrapper');
    if (!wrap) return [];
    return Array.prototype.filter.call(wrap.children, function (el) {
      return el.querySelector('.footer-block__heading') &&
        el.querySelector('.footer-block__details-content');
    });
  }

  function build() {
    if (built.length) return;

    blocks().forEach(function (block, index) {
      // The brand block leads the footer and stays open.
      if (index === 0) return;

      var heading = block.querySelector('.footer-block__heading');
      var content = block.querySelector('.footer-block__details-content');
      if (!heading || !content) return;

      var details = document.createElement('details');
      details.className = CLASS;

      var summary = document.createElement('summary');
      summary.className = CLASS + '__summary';

      // The heading moves inside the summary rather than being duplicated, so
      // the document keeps exactly one <h2> per block.
      summary.appendChild(heading);

      var chevron = document.createElement('span');
      chevron.className = CLASS + '__chevron mdm-icon';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.textContent = 'expand_more';
      summary.appendChild(chevron);

      details.appendChild(summary);
      details.appendChild(content);
      block.appendChild(details);

      built.push({ block: block, details: details, heading: heading, content: content });
    });
  }

  function teardown() {
    built.forEach(function (item) {
      item.block.appendChild(item.heading);
      item.block.appendChild(item.content);
      item.details.remove();
    });
    built = [];
  }

  function sync(matches) {
    if (matches) {
      build();
    } else {
      teardown();
    }
  }

  function init() {
    if (!document.querySelector('.footer__blocks-wrapper')) return;
    var mq = window.matchMedia(BREAKPOINT);
    sync(mq.matches);
    if (mq.addEventListener) {
      mq.addEventListener('change', function (event) { sync(event.matches); });
    } else if (mq.addListener) {
      mq.addListener(function (event) { sync(event.matches); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
